export function roleIndexValidate(rol){
    var result = true;

    result = validateId(rol.id);
    result = validateName(rol.name);
    result = validateIsForClients(rol.is_for_clients);

    return result;
}

function validateId(id){    
    if(Number.isInteger(id)) return true;
    else return false;
}

function validateName(name){
    if(typeof name == "string" && name !== "") return true;
    else return false;
}

function validateIsForClients(is_for_clients){
    if(typeof is_for_clients == 'boolean') return true;
    else return false;
}